import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock, EyeOff, FileText, ArrowRight } from "lucide-react";

export default function Privacy() {
  const sections = [
    {
      title: "Information Collection",
      content: "We collect details such as name and contact number when you submit an inquiry. This data is essential for procurement documentation.",
      icon: <FileText size={20} className="text-[#D4AF37]" />
    },
    {
      title: "Operational Usage",
      content: "Your information is used to facilitate farm visits, issue health certificates, and coordinate logistics for animal transport.",
      icon: <ShieldCheck size={20} className="text-[#2D5A27]" />
    },
    {
      title: "Data Protection",
      content: "We employ industry-standard encryption to protect transaction records and prevent unauthorized access to farmer data.",
      icon: <Lock size={20} className="text-[#D4AF37]" />
    },
    {
      title: "Zero-Sharing Policy",
      content: "We do not sell your personal information. Data is only shared with verified government officers for legal livestock movement.",
      icon: <EyeOff size={20} className="text-[#2D5A27]" />
    }
  ];

  return (
    <div className="bg-[#FDFCF8] min-h-screen pt-16 pb-12 overflow-x-hidden">
      <div className="max-w-4xl mx-auto px-6">
        
        <div className="mb-10 text-center md:text-left pt-4">
          <span className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] block mb-2">
            Legal Framework
          </span>
          <h1 className="text-4xl md:text-5xl font-black text-[#4B3621] tracking-tighter mb-4">
            Privacy <span className="text-[#2D5A27]">Policy.</span>
          </h1>
          <div className="w-12 h-1 bg-[#D4AF37] mb-6 mx-auto md:mx-0"></div>
          <p className="text-gray-500 text-sm font-medium leading-relaxed max-w-2xl">
            Effective: Dec 2025. This policy outlines our commitment to protecting the 
            digital and personal integrity of our agricultural partners.
          </p>
        </div>

        <div className="space-y-4">
          {sections.map((section, i) => (
            <div key={i} className="group flex flex-col md:flex-row gap-6 items-start p-6 rounded-3xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all">
              <div className="p-3 bg-[#FDFCF8] rounded-xl group-hover:scale-105 transition-transform">
                {section.icon}
              </div>
              <div>
                <h3 className="text-sm font-black text-[#4B3621] uppercase tracking-tight mb-2">
                  {section.title}
                </h3>
                <p className="text-gray-500 text-[12px] leading-relaxed font-medium">
                  {section.content}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 relative overflow-hidden p-8 rounded-[2rem] bg-[#4B3621] text-white">
          <div className="absolute -right-6 -bottom-6 text-[6rem] font-black text-white/5 select-none pointer-events-none">
            DATA
          </div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h4 className="text-xl font-black mb-1 tracking-tighter italic">Data Questions?</h4>
              <p className="text-white/50 text-[11px] max-w-xs">
                Request an audit or speak with our compliance officer via our secure portal.
              </p>
            </div>
            
            <Link 
              to="/contact" 
              className="flex items-center gap-3 bg-[#D4AF37] text-[#4B3621] px-8 py-4 rounded-xl font-black text-[10px] uppercase tracking-[0.2em] hover:bg-white hover:scale-105 transition-all shadow-xl group"
            >
              Open Inquiry Form 
              <ArrowRight size={14} className="group-hover:translate-x-2 transition-transform" />
            </Link>
          </div>
        </div>

        <p className="mt-8 text-center text-[8px] font-bold text-gray-500 uppercase tracking-widest leading-normal">
          Guru's Research Farms reserves the right to update this policy <br /> 
          to reflect changes in agricultural data laws.
        </p>

      </div>
    </div>
  );
}